import { MvnCodeFE } from "./const";
import { MvnCodeInitiate } from "../lib/const";

export const DASHBOARD_LANG: {
  NOTICE_EMPTY: MvnCodeFE;
  DASHBOARD_STATISTICS_MANAGEMENT_SUBJECT_EMPTY: MvnCodeFE;
  DASHBOARD_STATISTICS_MANAGEMENT_SUBJECT_DESCRIPTION: MvnCodeFE;
  DASHBOARD_STATISTICS_MANAGEMENT_SUBJECT_SUMMARY: MvnCodeFE;
  DASHBOARD_STATISTICS_BAR_DESCRIPTION: MvnCodeFE;
  DASHBOARD_STATISTICS_BAR_CONTENT: MvnCodeFE;
  DASHBOARD_STATISTICS_BY_SITE_TITLE: MvnCodeFE;
  DASHBOARD_STATISTICS_BY_MONTH_TITLE: MvnCodeFE;
  DASHBOARD_STATISTICS_BY_SITE_CONTENT: MvnCodeFE;
  DASHBOARD_STATISTICS_BY_SITE_DESCRIPTION: MvnCodeFE;
  DASHBOARD_STATISTICS_BY_MONTH_CONTENT: MvnCodeFE;
  DASHBOARD_STATISTICS_BY_MONTH_DESCRIPTION: MvnCodeFE;
} = {
  NOTICE_EMPTY: {
    ko: "등록된 공지사항이 없습니다.",
    en: "There is no notice to display.",
  },
  DASHBOARD_STATISTICS_MANAGEMENT_SUBJECT_EMPTY: {
    ko: "등록된 Subject가 없습니다.",
    en: "There are no registered subjects.",
  },
  DASHBOARD_STATISTICS_MANAGEMENT_SUBJECT_DESCRIPTION: {
    ko: "* 전체 Subject에 대하여 현재 진행 상태를 요약한 정보입니다.",
    en: "* Information that summarizes the current progress for all subjects.",
  },
  DASHBOARD_STATISTICS_MANAGEMENT_SUBJECT_SUMMARY: {
    ko: "(전체 Subject 수: {total})",
    en: "(Total Number of Subjects: {total})",
  },
  DASHBOARD_STATISTICS_BAR_DESCRIPTION: {
    ko: "* Subject별 상태 변화에 대한 누적 통계 정보입니다.",
    en: "* Cumulative statistical information on status changes for each subject.",
  },
  DASHBOARD_STATISTICS_BAR_CONTENT: {
    ko: "(각 데이터의 합계가 전체 Subject 수를 의미하지 않습니다.)",
    en: "(The sum of all data does not mean the total number of Subjects.)",
  },
  DASHBOARD_STATISTICS_BY_SITE_TITLE: {
    ko: "Subject Status Statistics by Site",
    en: "Subject Status Statistics by Site",
  },
  DASHBOARD_STATISTICS_BY_MONTH_TITLE: {
    ko: "Subject Status Statistics by Month",
    en: "Subject Status Statistics by Month",
  },
  DASHBOARD_STATISTICS_BY_SITE_CONTENT: {
    ko: "* Site별 Subject의 등록 통계 정보입니다.",
    en: "The enrollment statistics information of subject by site.",
  },
  DASHBOARD_STATISTICS_BY_SITE_DESCRIPTION: {
    ko: "{year}년 {month}월 '{text}'(으)로 입력된 Subject 수",
    en: "Number of subjects entered as '{text}' in {year}.{month}",
  },
  DASHBOARD_STATISTICS_BY_MONTH_CONTENT: {
    ko: "* 모든 Site의 Subject 입력과 누적 현황 정보입니다.",
    en: "Subject and cumulative status information of all sites.",
  },
  DASHBOARD_STATISTICS_BY_MONTH_DESCRIPTION: {
    ko: "{date} '{text}' 상태인 모든 Site의 대상자 수",
    en: "{date} Subject number of all sites entered as '{text}'",
  },
};

MvnCodeInitiate(DASHBOARD_LANG);
